export const programMessages = {
  fr: {
    program: {
      generateSurvey: "Générer sondage",
      alertTitle: "Passer par l'onglet Préparation",
      investigationPlansTitle: "Plans d'investigations prévisionnelles",
      add: "Ajouter",
      toPreparation: "Vers Préparation",
      errorFetchingProvisionalProgram: "Erreur lors de la récupération du programme prévisionnel",
      errorFetchingWorkData: "Erreur lors de la récupération des ouvrages",
      soilArea: "Sols",
      ambientAirArea: "Air ambiant",
      excavatedSoilArea: "Terres excavées",
      groundwaterArea: "Eaux souterraines",
      soilGasArea: "Gaz du sol",
      sedimentsArea: "Sédiments",
      surfaceWaterArea: "Eaux superficielles",
      tapWaterArea: "Eaux de robinet",
      vegetationArea: "Végétaux",
      isAreaToInvestigate: "Milieu à investiguer",
      justificationActivatedByTransfer:
        "Milieu potentiellement impacté par les sources de pollutions identifiées",
      justificationActivatedWithoutTransfer: "Autre (à préciser)",
      justificationNotActivatedNoTransfer: "Milieu non impacté par les sources identifiées",
      justificationNotActivatedWithTransfer1:
        "Milieu non retenu en première approche. En attente des résultats sur les sols",
      justificationNotActivatedWithTransfer2: "Milieu non retenu selon le souhait du client.",
      justificationNotActivatedWithTransfer3: "Autre (à préciser)",
      justificationExcavatedSoilArea: "Milieu non présent",
      // Anciennes clés conservées pour compatibilité
      justificationYesNoModif:
        "Milieu potentiellement impacté par les sources de pollutions identifiées",
      justificationYesModified1:
        "Milieu non retenu en première approche. En attente des résultats sur les sols",
      justificationYesModified2: "Milieu non retenu selon le souhait du client.",
      justificationYesModified3: "Autre (à préciser)",
      justificationNoNoModif: "Milieu non impacté par les sources identifiées",
      justificationNoModified: "Milieu retenu à la demande du client.",
      justification: "Justification",
      worksList: "Liste des ouvrages",
      workModalTitle: "Ajouter / Éditer ouvrage",
      workName: "Nom ouvrage",
      prefix: "Préfixe",
      number: "Numéro",
      workNamePlaceholder: "Nom de l'ouvrage",
      cancel: "Annuler",
      depth: "Profondeur de l'ouvrage",
      confirm: "Confirmer",
      methanolKit: "Utilisation d'un kit méthanol",
      workType: "Type de l'ouvrage",
      existingWork: "Ouvrage existant",
      isProvenHydraulicPosition: "Position hydraulique avérée",
      hydraulicPosition: "Position hydraulique",
      localization: "Localisation",
      formValidationError: "Le formulaire est invalide, veuillez vérifier les champs obligatoires.",
      PIEZAIR: "Piezair",
      PIEZOMETER: "Piezomètre",
      samplingHeight: "Hauteur de prélèvement ",
      VAPOR_PIN: "Air sous dalle / Vapor pin",
      GAS_CANE: "Canne gaz",
      PIEZO: "Piézo",
      EXISTING_WORK: "Puits / forage",
      DOWNSTREAM: "Aval",
      UPSTREAM: "Amont",
      LATERAL: "Latérale",
      UPSTREAM_LATERAL: "Amont latéral",
      DOWNSTREAM_LATERAL: "Aval latéral",
      UNKNOWN: "Inconnue",
      REJECT: "Au rejet",
      no: "Non",
      yes: "Oui",
      sourceTitle: "Source",
      tracerCompound: "Composés traceurs",
      depthTitle: "Profondeur",
      complementaryInformation: "Informations complémentaires",
      editSource: "Ajouter / Éditer source",
      suspectedPollutants: "Polluants recherchés",
      noWorksForComponent: "Aucun ouvrage n'est associé à cette source",
      pipeType: "Type de tubage",
      programValidated:
        "Votre programme prévisionnel a été validé avec succès. Vous pouvez aller sur l'onglet suivant 'Comparer programme et investigations'",
      drillingMaterials: "Matériels de forage",
      samplingMaterials: "Matériels de prélèvement",
      surveysGenerated: "Vos sondages ont été générés avec succès.",
      modificationVerificationText:
        "Vous êtes sur le point de modifier le programme prévisionnel. Cette action est irréversible et entraine la réinitialisation de la comparaison entre le programme prévisionnel et les investigations. Voulez-vous continuer ?",
      modificationVerificationTitle: "Modification du programme prévisionnel",
      true: "Oui",
      false: "Non",
      works: "Ouvrages",
      actions: "Actions",
    },
    PVC: "PVC",
    PEHD: "PEHD",
    INOX: "Inox",
    MANUAL_AUGER: "Tarière manuelle",
    PORTABLE_CORE_DRILL: "Carottier portatif",
    MECHANICAL_DRILL_CORE_DRILL: "Foreuse mécanique / Carottier",
    MECHANICAL_DRILL_MANUAL_AUGER: "Foreuse mécanique / Tarière",
    MECHANICAL_DRILL_CORE_DRILL_UNDER_SLEEVE: "Foreuse mécanique / Carottier sous gaine",
    EXCAVATOR: "Pelle mécanique",
    PORTABLE_CORE_DRILL_UNDER_SLEEVE: "Carottier portatif sous gaine",
    SCOOP: "Écope",
    SEDIMENT_BENNE: "Benne à sédiments",
    DRILL: "Carottier",
    yes: "Oui",
    no: "Non",
    false: "Non",
    true: "Oui",
    select: "Sélectionner",
  },
  en: {
    program: {
      generateSurvey: "Generate survey",
      alertTitle: "Go to the Preparation tab",
      investigationPlansTitle: "Provisional investigation plans",
      add: "Add",
      toPreparation: "To Preparation",
      errorFetchingProvisionalProgram: "Error fetching provisional program",
      errorFetchingWorkData: "Error fetching works data",
      soilArea: "Soil",
      ambientAirArea: "Ambient air",
      excavatedSoilArea: "Excavated soil",
      groundwaterArea: "Groundwater",
      sedimentsArea: "Sediments",
      soilGasArea: "Soil gas",
      surfaceWaterArea: "Surface water",
      tapWaterArea: "Tap water",
      vegetationArea: "Vegetation",
      isAreaToInvestigate: "Area to investigate",
      justificationActivatedByTransfer: "Area potentially impacted by identified pollution sources",
      justificationActivatedWithoutTransfer: "Other (to be specified)",
      justificationNotActivatedNoTransfer: "Area not impacted by identified sources",
      justificationNotActivatedWithTransfer1:
        "Area not retained in first approach. Awaiting results on soils",
      justificationNotActivatedWithTransfer2: "Area not retained at client's request.",
      justificationNotActivatedWithTransfer3: "Other (to be specified)",
      justificationExcavatedSoilArea: "Area not present",
      // Old keys kept for compatibility
      justificationYesNoModif: "Area potentially impacted by identified pollution sources",
      justificationYesModified1: "Area not retained in first approach. Awaiting results on soils",
      justificationYesModified2: "Area not retained at client's request.",
      justificationYesModified3: "Other (to be specified)",
      justificationNoNoModif: "Area not impacted by identified sources",
      justificationNoModified: "Area retained at client's request.",
      justification: "Justification",
      worksList: "Works list",
      workModalTitle: "Add / Edit source",
      workNamePlaceholder: "Work name",
      workName: "Work name",
      prefix: "Prefix",
      number: "Number",
      cancel: "Cancel",
      confirm: "Confirm",
      depth: "Work depth",
      methanolKit: "Use of a methanol kit",
      workType: "Work type",
      existingWork: "Existing work",
      hydraulicPosition: "Hydraulic position",
      isProvenHydraulicPosition: "Proven hydraulic position",
      localization: "Location",
      samplingHeight: "Sample height",
      formValidationError: "The form is invalid, please check the required fields.",
      PIEZAIR: "Piezair",
      VAPOR_PIN: "Air under slab / Vapor pin",
      GAS_CANE: "Gas can",
      PIEZOMETER: "Piezometer",
      PIEZO: "Piezo",
      EXISTING_WORK: "Well / borehole",
      UPSTREAM: "Upstream",
      DOWNSTREAM: "Downstream",
      LATERAL: "Lateral",
      UPSTREAM_LATERAL: "Upstream lateral",
      DOWNSTREAM_LATERAL: "Downstream lateral",
      UNKNOWN: "Unknown",
      REJECT: "Discharge",
      yes: "Yes",
      no: "No",
      sourceTitle: "Source",
      depthTitle: "Depth",
      tracerCompound: "Tracer compounds",
      complementaryInformation: "Complementary information",
      editSource: "Add / Edit source",
      suspectedPollutants: "Suspected pollutants",
      pipeType: "Pipe type",
      programValidated:
        "Your provisional program has been successfully validated. You can go to the next tab 'Compare program and investigations'",
      drillingMaterials: "Drilling materials",
      samplingMaterials: "Sampling materials",
      modificationVerificationText:
        "You are about to modify the provisional program. This action is irreversible and will reset the comparison between the provisional program and the investigations. Do you want to continue?",
      modificationVerificationTitle: "Modification of the provisional program",
      surveysGenerated: "Your surveys have been successfully generated.",
      false: "No",
      true: "Yes",
      works: "Works",
      actions: "Actions",
    },
    PEHD: "PEHD",
    PVC: "PVC",
    INOX: "Stainless steel",
    MANUAL_AUGER: "Manual auger",
    PORTABLE_CORE_DRILL: "Portable core drill",
    PORTABLE_CORE_DRILL_UNDER_SLEEVE: "Portable core drill under sleeve",
    MECHANICAL_DRILL_MANUAL_AUGER: "Mechanical drill / Auger",
    MECHANICAL_DRILL_CORE_DRILL: "Mechanical drill / Core drill",
    MECHANICAL_DRILL_CORE_DRILL_UNDER_SLEEVE: "Mechanical drill / Core drill under sleeve",
    EXCAVATOR: "Excavator",
    SEDIMENT_BENNE: "Sediment bucket",
    SCOOP: "Scoop",
    DRILL: "Core drill",
    yes: "Yes",
    no: "No",
    false: "No",
    true: "Yes",
    select: "Select",
  },
};
